module.exports = __webpack_public_path__ + "lding_blocks_1s_32px.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lding_blocks_1s_32px.gif
// module id = 423
// module chunks = 0